import { Keygen } from 'eosjs-keygen'
import React, { useState } from 'react'
import MainButton from '../../components/common/util/input/MainButton'
import { get, getTransaction } from '../../components/helpers/Api'
import { sleep } from '../../components/helpers/FormatLinks'
import LoadingIndicator from '../../components/loadingindicator'
import Page from '../../components/page/Page'

import { useSharedState } from '../../components/waxplorer/Waxplorer'

const LinkPage = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const parseNFTs = async (res) => {
        const nfts = []
        for (let asset of res) {
            const keys = await Keygen.generateMasterKeys()
            nfts.push({
                assetIds: asset.assetIds,
                publicKey: keys.publicKeys.active,
                privateKey: keys.privateKeys.active,
            })
        }

        for (let asset of nfts) {
            const actions = []

            actions.push({
                account: 'atomictoolsx',
                name: 'announcelink',
                authorization: [
                    {
                        actor: userName,
                        permission: activeUser.requestPermission
                            ? activeUser.requestPermission
                            : 'active',
                    },
                ],
                data: {
                    creator: userName,
                    key: asset.publicKey,
                    asset_ids: asset.assetIds,
                    memo: 'Berlin Web3',
                },
            })

            actions.push({
                account: 'atomicassets',
                name: 'transfer',
                authorization: [
                    {
                        actor: userName,
                        permission: activeUser.requestPermission
                            ? activeUser.requestPermission
                            : 'active',
                    },
                ],
                data: {
                    from: userName,
                    to: 'atomictoolsx',
                    asset_ids: asset.assetIds,
                    memo: 'link',
                },
            })

            const result = await activeUser.session.transact(
                {
                    actions: actions,
                },
                {
                    expireSeconds: 300,
                    blocksBehind: 0,
                },
            )

            let transaction = null

            while (!transaction) {
                transaction = await getTransaction(
                    result?.response?.transaction_id,
                )
                if (!transaction) {
                    sleep(1000)
                }

                if (
                    transaction &&
                    Object.keys(transaction).includes('actions')
                ) {
                    let found = false
                    for (const action of transaction.actions) {
                        if (action.act.name === 'lognewlink') {
                            const link_id = action.act.data.link_id
                            get(
                                `loglink?asset_ids=${asset.assetIds}&link_id=${link_id}&key=${asset.privateKey}`,
                            ).then(parseNFTs)
                            found = true
                        }
                    }
                    if (!found) {
                        transaction = null
                    }
                } else {
                    transaction = null
                }
            }
        }

        setIsLoading(false)
    }

    const generateNow = async () => {
        setIsLoading(true)
        get(`giveaway-nfts`).then(parseNFTs)
    }

    return (
        <Page id="LinkPage" banners={false} {...props}>
            {isLoading ? (
                <LoadingIndicator />
            ) : (
                <MainButton onClick={generateNow}>Generate</MainButton>
            )}
        </Page>
    )
}

export default LinkPage
